import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from 'antd'
import { Button } from 'ui/styled'

const ArchiveButton = ({
  archived,
  archiveItem,
  isDisabled,
  buttonStyle = {}
}) => (
  <Tooltip
    title={
      archived
        ? 'Unarchiving this request will make it reappear in the Member’s app.'
        : 'Archiving request will delete it in the Member’s app.'
    }
  >
    <Button
      btntype="danger"
      btnsize="custom"
      height="32px"
      onClick={archiveItem}
      disabled={isDisabled}
      data-test="ticketArchiveUnarchiveRequestButton"
      {...buttonStyle}
    >
      {`${archived ? 'Unarchive' : 'Archive'} Request`}
    </Button>
  </Tooltip>
)

ArchiveButton.propTypes = {
  archived: PropTypes.bool.isRequired,
  archiveItem: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  buttonStyle: PropTypes.object
}

export default ArchiveButton
